// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background-container {
    margin-top: 10px;
    margin-left: 5px;
    width: 260px;
    z-index: 10;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, .6);
    background: linear-gradient(to top, #eaeaea, #f3f3f3);
    display: flex;
    flex-direction: column;
}

.background-container div {
    display: flex;
    flex-direction: row;
}

.background-container h4 {
    margin-top: 10px;
    color: #333;
}

.background-container label {
    border: none;
    height: 30px;
    margin-top: 10px;
    margin-left: 5px;
    justify-content: center;
    display: flex;
    align-items: center;
}

.background-container input[type="color"] {
    margin-top: 10px;
    height: 30px;
    border: none;
    cursor: pointer;
    transition: box-shadow 0.3s ease;
    margin-left: 30px;
}`, "",{"version":3,"sources":["webpack://./src/BackgroundSetting.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,qDAAqD;IACrD,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gCAAgC;IAChC,iBAAiB;AACrB","sourcesContent":[".background-container {\n    margin-top: 10px;\n    margin-left: 5px;\n    width: 260px;\n    z-index: 10;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, .6);\n    background: linear-gradient(to top, #eaeaea, #f3f3f3);\n    display: flex;\n    flex-direction: column;\n}\n\n.background-container div {\n    display: flex;\n    flex-direction: row;\n}\n\n.background-container h4 {\n    margin-top: 10px;\n    color: #333;\n}\n\n.background-container label {\n    border: none;\n    height: 30px;\n    margin-top: 10px;\n    margin-left: 5px;\n    justify-content: center;\n    display: flex;\n    align-items: center;\n}\n\n.background-container input[type=\"color\"] {\n    margin-top: 10px;\n    height: 30px;\n    border: none;\n    cursor: pointer;\n    transition: box-shadow 0.3s ease;\n    margin-left: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
